import axios from 'axios';
import {config} from '../config';

export const transaction = (
    transactionType,
    amount,
    allowPinBypass,
    id
) => {
    const convertedAmount = parseInt(amount);
    const transactionRequest = {
        method: 'post',
        headers: {
            Authorization: 'bearer ' + localStorage.tokens,
            'Content-Type': 'application/json',
        },
        url: `${config.endpoint}/v1/terminal/${id}/transaction`,
        data: { 'transactionType': transactionType, 'amount': convertedAmount, 'allowPinBypass': allowPinBypass, 'operatorId':localStorage.operatorId.length < 4 ?'0000':localStorage.operatorId },
    };
        return axios(transactionRequest)
        .then((res) => {return res;})
        .catch(err => {return err;} 
        );
};

export const reversal = (
    transactionType,
    amount,
    allowPinBypass,
    id
) => {
    const convertedAmount = parseInt(amount);
    const transactionRequest = {
        method: 'post',
        headers: {
            Authorization: 'bearer ' + localStorage.tokens,
            'Content-Type': 'application/json',
        },
        url: `${config.endpoint}/v1/terminal/${id}/transaction`,
        data: {'transactionType': transactionType, 'amount': convertedAmount, 'allowPinBypass': allowPinBypass, 'operatorId':localStorage.operatorId.length < 4 ?'0000':localStorage.operatorId },
    };
    return axios(transactionRequest)
        .then((res) => {return res;})
        .catch(err => {return err;} 
        );
};

export const refund = (
    amount,
    id
) => {
    const convertedAmount = parseInt(amount);
    const transactionRequest = {
        method: 'post',
        headers: {
            Authorization: 'bearer ' + localStorage.tokens,
            'Content-Type': 'application/json',
        },
        url: `${config.endpoint}/v1/terminal/${id}/transaction`,
        data: { 'transactionType': 'returnOfGoods', 'amount': convertedAmount,'operatorId':localStorage.operatorId.length < 4 ?'0000':localStorage.operatorId },
    };
    return axios(transactionRequest)
        .then((res) => {return res;})
        .catch(err => {return err;} 
        );
};

export const cancelTransaction = (
    id
) => {
    const transactionRequest = {
        method: 'post',
        headers: {
            Authorization: 'bearer ' + localStorage.tokens,
            'Content-Type': 'application/json',
        },
        url: `${config.endpoint}/v1/terminal/${id}/administration`,
        data: { 'action': 'cancelAction','operatorId':localStorage.operatorId.length < 4 ?'0000':localStorage.operatorId },
    };
    return axios(transactionRequest)
        .then((res) => {return res;})
        .catch(err => {return err;});
};

export const cashbackTransaction = (
    amount,
    cbAmount,
    allowPinBypass,
    id
) => {
    const convertedAmount = parseInt(amount);
    const convertedCbAmount = parseInt(cbAmount);
    const transactionRequest = {
        method: 'post',
        headers: {
            Authorization: 'bearer ' + localStorage.tokens,
            'Content-Type': 'application/json',
        },
        url: `${config.endpoint}/v1/terminal/${id}/transaction`,
        data: { 'transactionType':'purchaseWithCashback',
        'amount': convertedAmount ,
        'amountCashback':convertedCbAmount,
        'allowPinBypass':allowPinBypass,'operatorId':localStorage.operatorId.length < 4 ?'0000':localStorage.operatorId },
    };
    return axios(transactionRequest)
        .then((res) => {return res;})
        .catch(err => {return err;} 
        );
};

export const getTerminalDetail = (
    id
) => {
    const transactionRequest = {
        method: 'get',
        headers: {
            Authorization: 'bearer ' + localStorage.tokens,
            'Content-Type': 'application/json',
        },
        url: `${config.endpoint}/v1/terminal/${id}`
    };
    return axios(transactionRequest)
        .then((res) => {return res;})
        .catch(err => {return err;});
};